import type { PortalNotification } from './notificationHref';

export function isCreditDecision(notification: PortalNotification): boolean {
  return notification.type === 'motor_credit_approved' || notification.type === 'motor_credit_rejected';
}

/** Match the discount flow: live matching page gets a popup; recovery goes to the bell. */
export function showCreditPopup(notification: PortalNotification, source: string, pathname: string, search: string): boolean {
  if (!isCreditDecision(notification) || source !== 'live') return false;
  if (pathname.replace(/\/$/, '') !== '/dashboard/products/motor/documentation') return false;
  return new URLSearchParams(search).get('quotationNo') === notification.quotation_no;
}
